import React from "react";
import { Redirect } from "@reach/router";

export default function ProtectedRoute({ children }) {
  const authToken = localStorage.getItem("auth_token");
  const isPublicEvent = localStorage.getItem("publicEvent") === "true";

  if (authToken || isPublicEvent) {
    return children;
  }

  return <Redirect to="/" noThrow />;
}
